import axios from "axios";

function profileEndpoint() {
  const baseApi = process.env.VUE_APP_BASEAPI || "";
  return `${baseApi.replace(/\/$/, "")}/api/profile`;
}

export default async function Auth({ next, store, to }) {
  const isLoggedIn = store.state.auth.autenticado;

  if (isLoggedIn) {
    return next();
  }

  try {
    const response = await axios.get(profileEndpoint(), {
      withCredentials: true,
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    if (response && response.data && response.data.data) {
      store.commit("auth/SET_USUARIO", response.data.data);
      store.commit("auth/SET_AUTENTICADO", true);
      return next();
    }
  } catch (e) {
    //
  }

  return next({
    name: "Login",
    query: {
      redirect: to.fullPath,
    },
  });
}
